import React, { useState, useEffect } from 'react';
import createPlotlyComponent from 'react-plotly.js/factory';
import Plotly from 'plotly.js/lib/core';

import treemap from 'plotly.js/lib/treemap';

import { Box, CircularProgress, Typography } from '@mui/material';

Plotly.register([treemap]);
const Plot = createPlotlyComponent(Plotly);

const SpendByVendorTreemap = ({ purchaseOrders = [] }) => {
  const [treeMapData, setTreeMapData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!purchaseOrders || purchaseOrders.length === 0) {
      setLoading(false);
      return;
    }

    try {
      let labels = ['Root'];
      let parents = [''];
      let values = [0];

      purchaseOrders.forEach((item) => {
        if (item?.vendorname && item?.netamount) {
          const vendor = item.vendorname;
          const netAmount = Number(item.netamount) || 0;

          if (!labels.includes(vendor)) {
            labels.push(vendor);
            parents.push('Root');
            values.push(netAmount);
          } else {
            const index = labels.indexOf(vendor);
            values[index] += netAmount;
          }
        }
      });

      setTreeMapData({
        data: [
          {
            type: 'treemap',
            labels: labels,
            parents: parents,
            values: values,
            textinfo: 'label+value+percent parent+percent entry',
            outsidetextfont: { size: 18, color: '#377eb8' },
            marker: { line: { width: 2 } },
            pathbar: { visible: false },
          },
        ],
        layout: {
          title: 'Vendor Spend by Purchase Orders',
          responsive: true,
          autosize: true,
          paper_bgcolor: 'rgba(0,0,0,0)',
          plot_bgcolor: 'rgba(0,0,0,0)',
          margin: { l: 40, r: 40, b: 40, t: 40, pad: 2 },
        },
        config: { responsive: true },
      });
    } catch (error) {
      setError('Error processing data.');
    } finally {
      setLoading(false);
    }
  }, [purchaseOrders]);

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 2, // Adds padding for smaller screens
      }}
    >
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography color="error">Error loading vendor spend data.</Typography>
      ) : treeMapData ? (
        <Box sx={{ width: '100%', height: '100%' }}>
          <Plot
            data={treeMapData.data}
            layout={treeMapData.layout}
            config={treeMapData.config}
            style={{ width: '100%', height: '100%' }}
          />
        </Box>
      ) : (
        <Typography>No data available.</Typography>
      )}
    </Box>
  );
};

export default SpendByVendorTreemap;
